




import { Vue, Component, Prop, Emit } from 'vue-property-decorator';
import i18n from '@/plugins/i18n';
import {uniqueId} from 'lodash';
import * as Api from "@/app/interaction/api";
import { BlockFileContent, BlockFileState } from "./block-file-interfaces";
import FileComponent, { FileDetails } from '@/app/file/ui/file-component.vue';

const PREVIEW_ENABLED_MIME_TYPES = ['application/pdf'];

@Component({
  components: {
    FileComponent
  }
})
export default class BlockFileComponent extends Vue implements Api.InteractiveComponent<BlockFileState, BlockFileContent> {
  
  @Prop({
    required: true
  })
  public meta: Api.InteractionComponentMeta;
  
  @Prop({
    required: true
  })
  public content: BlockFileContent;
  
  @Prop({
    required: true
  })
  public state: BlockFileState | null;
  
  private get fileDetails() {
    const details: FileDetails = {
      title: this.meta.title || '',
      description: this.content.description,
      uri: this.content.uri,
      mimeType: this.content.mimeType,
      originalFilename: this.content.originalFilename,
      size: this.content.size
    }
    return details
    }

    @Emit('interaction-result-changed')
    public emitInteractionResultChanged() {

      const result: Api.Result = {
        progress: 1,
        status: 'completed'
      }
      return result      
    }

    @Emit('interaction-state-changed')
    public emitInteractionStateChanged() {
      return {
        state: {}
      };
    }
  }
